(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

$(document).ready(function () {
	$('#content_wrapper h2').each(function (i) {
		$(this).attr('rel', i);
		$(this).nextUntil('h2').wrapAll('<div class="popUpContent hide" id="pop-up-' + i + '" />');
	});
	$('#content_wrapper h2').click(function () {
		if ($('#pop-up-' + $(this).attr('rel')).hasClass('hide')) {
			$('#pop-up-' + $(this).attr('rel')).removeClass('hide');
		} else {
			$('#pop-up-' + $(this).attr('rel')).addClass('hide');
		}
	});
	$('.popUpContent .close').click(function () {
		$(this).parent().addClass('hide').unwrap();
	});
});

$(document).on('click', '.by_three, #left_col li', function () {
	window.location = '/resources/support-info/' + $(this).data('category');
});

},{}]},{},[1]);
